var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLastMoveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    transform: "rotate(-180 42 42)",
    fill: "#B6C5DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 65C55.5 65.8284 56.1716 66.5 57 66.5C57.8284 66.5 58.5 65.8284 58.5 65L55.5 65ZM58.5 19.5C58.5 18.6716 57.8284 18 57 18C56.1716 18 55.5 18.6716 55.5 19.5L58.5 19.5ZM58.5 65L58.5 19.5L55.5 19.5L55.5 65L58.5 65Z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1215 18.6289C27.5024 18.0785 26.5543 18.1343 26.0039 18.7535C25.4535 19.3726 25.5093 20.3207 26.1285 20.8711L28.1215 18.6289ZM51.875 41.75L52.9049 42.8405C53.2107 42.5518 53.3812 42.1479 53.3748 41.7274C53.3685 41.3068 53.1859 40.9083 52.8715 40.6289L51.875 41.75ZM26.0951 64.0345C25.4928 64.6033 25.4657 65.5527 26.0345 66.1549C26.6033 66.7572 27.5527 66.7843 28.1549 66.2155L26.0951 64.0345ZM26.1285 20.8711L50.8785 42.8711L52.8715 40.6289L28.1215 18.6289L26.1285 20.8711ZM50.8451 40.6595L26.0951 64.0345L28.1549 66.2155L52.9049 42.8405L50.8451 40.6595Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastMoveIcon);
export default __webpack_public_path__ + "static/media/LastMoveIcon.6a55a98b40574e00447e631c2609a532.svg";
export { ForwardRef as ReactComponent };